import styled from 'styled-components'

import { PolicyList as DefaultPolicyList } from 'components/Lists'

export const PolicyList = styled(DefaultPolicyList)`
	padding: 16px 0 32px;
	border-top: 1px solid ${({ theme }) => theme.color.divider};
`
